import type { ReactNode } from 'react';

import './PanelRow.scss';

interface IPanelRowProps {
  label: ReactNode;
  value: ReactNode;
  empty?: boolean;
}

const PanelRow = ({ label, value, empty = false }: IPanelRowProps) => {
  const valueClass = ['panel-row__value', empty ? 'panel-row__value--empty' : ''].filter(Boolean).join(' ');

  return (
    <div className="panel-row">
      <span className="panel-row__label">{label}</span>
      <span className={valueClass}>{value}</span>
    </div>
  );
};

export default PanelRow;
